<template>
  <div class="invest-point" :class="{'isiOSX':isiOSX}">
    <van-nav-bar class="invest-title" :fixed="true" title="红包中心"/>
    <img @click="prev" class="invest-reback" src="../../assets/myInvest/reback.png">
    <div class="tab_change" :style="boxHei">
      <van-tabs sticky scroll="{ scrollTop: 64, isFixed: true }">
        <van-tab title="红包收入">
            <pointsList param="2,1"/>
        </van-tab>
        <van-tab title="红包消费"> 
        		<pointsList param="2,2"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import pointsList from './points_list.vue';
export default {
	components: {
		pointsList
	},
	data() {
    return {
      isiOSX: false,
      boxHei: {height: document.body.clientHeight+'px'}
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  },
  methods: {
  	prev() {
  		this.$router.go(-1);
  	},
  }
};
</script>
<style lang="less" >
	.invest-point{
		background-color: #f2f2f2;
  	min-height: 100%;
		.invest {
		  &-title {
		    height: 44px;
		    line-height: 44px;
		    padding-top: 24px;
		    box-shadow: 0 1px 0 #eee;
		    .van-nav-bar__title {
		      color: #333;
		      font-size: 17px;
		      font-weight: 700;
		    }
		  }
		  &-reback {
		    width: 15px;
		    padding: 12px 15px;
		    position: fixed;
		    top: 29px;
		    left: 0;
		    z-index: 1;
		  }
		}
		.tab_change {
		  padding-top: 69px;
		  box-sizing: border-box;
		  .van-sticky{
				position: fixed;
				top: 69px;
				width: 100%;
				z-index: 2;
				.van-tab {
					color: #999;
					font-size: 16px;
				}
				.van-tab--active{
					color: #1D1E1F;
					font-weight: bold;
					font-size: 16px;
				}
				.van-tabs__line{
					background-color: #1D1E1F !important;
				}
			}
			.van-tab__pane{
				padding-top: 44px;
			}
		}
	}
	.isiOSX {
		.invest {
		  &-title {
		    padding-top: 44px;
		  }
		  &-reback {
		    top: 45px;
		  }
		}
		.tab_change {
		  padding-top: 89px;
		  .van-sticky{
				top: 89px;
			}
		}
	}
</style>
<style scoped>
.invest-point >>> [class*="van-hairline"]::after {
  border: none;
}
</style>


